import React, { Component } from 'react';
import SelectInput, { findItem } from 'Components/forms/select-input/SelectInput.jsx';
import Label from 'Components/forms/label/Label';
import TextField from 'Components/forms/text-field/TextField';
import Checkbox from 'Components/forms/checkbox/Checkbox.jsx';
import SingleDateInput from 'Components/forms/SingleDateInput/SingleDateInput';
import TextInput from 'Components/forms/text-input/TextInput';
import TimePickerTool from 'Components/TimePickerTool/TimePickerTool.jsx';
import ResponseBanner from 'Components/cards/ResponseBanner';
import moment from 'moment';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import { fetchLevelOneQuestionnaireComponents, fetchLevelTwoQuestionnaireComponents, fetchLevelThreeQuestionnaireComponents, getQuestionnaireAutoPopulateDetails } from '../../api/caseDataAPI';
import { getLevelOneComponents, getLevelTwoComponents, getLevelThreeComponents } from './configstructure';
import './Questionnaire.scss';
import {
    __CE_COMPELLING_EVIDENCE__, __ID_INVALID_DISUTE__, __ND_CARDHOLDER_NO_LONGER_DISPUTES__,
    __DC_DELAYED_CHARGE_TRANSACTION__,
    __EVIDENCE_OF_IMPRINT__,__CP_CREDIT_OR_REVERSAL_PROCESSED__,
    __DROP_DOWN__, __ATTACH_DOCUMENT__, __PUSH__, __POP__, __INDEX_ZERO__,
    __CNLD_CARDHOLDER_NO_LONGER_DISPUTES__,
    __NL_NOT_LISTED_ABOVE__,
    __RM_REVERSAL_ISSUED_BY_MERCHANT__,
    __ALOC__, __COLB__,
    __cce04DescDownloaded__, __cce04DownloadDate__, __cce04DownloadTime__,__FC__,
    __CDLT__, __ALLOCATION__, __COLLABORATION__, __IDRA4__, __CP01__, __IDRA1__, __IDRA2__, __IDRA3__, __CP02__, __IDRA5__, __IDRA6__, __IDRA7__, __CE03__, __CE04__, __CE09__, __CE13__, __IDRC3__, __IDRC25__,
    __idCollaborationCheckbox__, __ace04ProofWebAccess__, __ace04DescProof__, __ace04EvidenceWebAccess__, __ace04DescEvid__, __ace04EvidenceSameDevice__, __ace04ARN__, __ace04TransacAmount__, __ace04TranDate__, __ace04PurchaserIp__, __ace04GeoLocation__, __ace04GeoPurcheserIP__, __ace04PurchaserName__, __ace04PurchasrEmail__, __ace04PurchasrName__, __ace04DeviceIDName__, __ace04DevId__, __ace04DeviceName__, __cce04ProofWebAccess__, __cce04DescProof__, __cce04EvidenceWebAccess__, __cce04DescEvid__, __cce04EvidenceSameDevice__, __ace09EvidenceSameDevice__, __cce04ARN__, __cce04TransacAmount__, __cce04TranDate__, __cce04PurchaserIp__, __cce04GeoLocation__, __cce04GeoPurcheserIP__, __cce04PurchaserName__, __cce04PurchasrEmail__, __cce04PurchasrName__, __cce04DeviceIDName__, __cce04DevId__, __cce04DeviceName__, __ce04EvidenceSameDeviceCheckBox__, __ace04DescDownloaded__, __ace04DownloadDate__, __ace04DownloadTime__,
    __REASON_CODE_121__, __REASON_CODE_124__, __REASON_CODE_125__, __REASON_CODE_126__, __REASON_CODE_127__, __REASON_CODE_104__, __REASON_CODE_131__, __REASON_CODE_139__, __REASON_CODE_103__, __REASON_CODE_101__,
    __REASON_CODE_122__, __REASON_CODE_123__, __REASON_CODE_132__, __REASON_CODE_133__, __REASON_CODE_134__, __REASON_CODE_135__, __REASON_CODE_136__, __REASON_CODE_137__, __REASON_CODE_138__,__REASON_CODE_111__,__REASON_CODE_112__,__REASON_CODE_113__,__CE17__,__CE18__,__REASON_CODE_102__,__REASON_CODE_105__,__REASON_CODE_1261__,__REASON_CODE_1262__, __colbAuthorizationDate__, __colbCancellationDate__, __colbTransactionDate__, __SINGLEDATE__,__SINGLECRCTTRSNDATE__, __DROPDOWN__, __INVALID_DISPUTE_REASON__,__CE16__
} from './QuestionnaireConstants';
import ImagePortal from 'Containers/ImagePortal';
import { COLORS } from "Constants/BIDashboardConstants"
 
const dcValidReasonCodes = [__REASON_CODE_101__, __REASON_CODE_102__, __REASON_CODE_103__, __REASON_CODE_104__];

class Questionnaire extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDocIndBanner: false,
            autoPopulateDetails: [],
        }
        this.attachBindings();
    }
    attachBindings() {
        this.onSelectionChange = this.onSelectionChange.bind(this);
        this.setLevelTwoComponents = this.setLevelTwoComponents.bind(this);
        this.setLevelThreeComponents = this.setLevelThreeComponents.bind(this);
        this.toggleCheckBoxes = this.toggleCheckBoxes.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
        this.onSingleDateChange = this.onSingleDateChange.bind(this);
        this.setComponentForDifferentLevels = this.setComponentForDifferentLevels.bind(this);
        this.addSecondaryColumns = this.addSecondaryColumns.bind(this);
        this.setSelectedDataColumns = this.setSelectedDataColumns.bind(this);
        this.performLevelTwoPreValidations = this.performLevelTwoPreValidations.bind(this);
        this.performLevelThreeValidations = this.performLevelThreeValidations.bind(this);
        this.validateCE04 = this.validateCE04.bind(this);
        this.nextButtonForIDRA6andIDRA7 = this.nextButtonForIDRA6andIDRA7.bind(this);
        this.setDifferentComponentLevels = this.setDifferentComponentLevels.bind(this);
        this.filterQuestionnaireComponentWithAPIs = this.filterQuestionnaireComponentWithAPIs.bind(this);
        this.renderResponseBanner = this.renderResponseBanner.bind(this);
        this.renderInvalidSelectionResponseBanner = this.renderInvalidSelectionResponseBanner.bind(this);
        this.onCloseDocIndicator = this.onCloseDocIndicator.bind(this);
        this.setQuestionnaireReviewData = this.setQuestionnaireReviewData.bind(this);
        this.renderInvalidSelectionResponseBanner = this.renderInvalidSelectionResponseBanner.bind(this);
    }
    componentWillMount() {
        if (!this.props.dataColumns) {
            this.setDifferentComponentLevels();
        } else {
            let dataColumns = Object.assign([], this.props.dataColumns);
            let initialDataColumns = Object.assign([], this.props.levelOneInitialQuesDataColumns);
            let prevLevelThreeDataColumns = Object.assign([], this.props.prevLevelThreeQuesDataColumns);
            //let attachArrayColumns = Object.assign([], this.props.attachArrayColumns);
            let levelTwoComponents = Object.assign([], this.props.levelTwoComponents);
            let levelThreeComponents = Object.assign([], this.props.levelThreeComponents);
            let levelOneComponents = Object.assign([], this.props.levelOneComponents);

            this.setState({
                dataColumns,
                initialDataColumns,
                prevLevelThreeDataColumns,
                // attachArrayColumns,
                levelTwoComponents,
                levelThreeComponents,
                levelOneComponents,
            })
        }
    }

    filterQuestionnaireComponentWithAPIs(apiComponentList, uiComponentList, level) {
        // TODO:UI components is to be replaced with API response.
        let filteredComponents = [];
        switch (level) {
            case 1:
                let refactoredApiComponentList = this.getComponentList(apiComponentList);
                let refactoredUIComponentList = this.getComponentList(uiComponentList);

                refactoredUIComponentList.forEach((action) => {
                    const occuranceIndex = refactoredApiComponentList.findIndex((item) => item.disputeType === this.props.disputeType && !action.dataColumnKey && !action.reason);
                    if (occuranceIndex !== -1) {
                        let index = 0;
                        let tempDataColumns = Object.assign([], action.dataColumns);
                        tempDataColumns.forEach((dataColumn) => {
                            const dataColumnListIndex = refactoredApiComponentList[occuranceIndex].dataColumns?.findIndex((item) =>
                                item.displayType === 'DROPDOWN' && dataColumn.columnKey == item.columnKey
                            );
                            if (dataColumnListIndex !== -1) {
                                //  tempDataColumns[index].list = refactoredApiComponentList[occuranceIndex].dataColumns[dataColumnListIndex].list;
                                tempDataColumns[index].list = this.getResponseReasonFilteredByReasonCode(refactoredApiComponentList[occuranceIndex].dataColumns[dataColumnListIndex].list);
                            }
                            index++;
                        })
                        action.dataColumns = [...tempDataColumns];
                        filteredComponents = filteredComponents.concat(action);
                    }
                });
                this.setState({
                    levelOneComponents: filteredComponents,
                })
                // Sets the initialList / dataColumns as level one components
                let initialList = Object.assign([], filteredComponents);
                for (let i = __INDEX_ZERO__; i < initialList.length; i++) {
                    if (initialList[i].disputeType === this.props.disputeType) {
                        this.setState({
                            dataColumns: initialList[i].dataColumns,
                            initialDataColumns: initialList[i].dataColumns,
                        })
                        break;
                    }
                }
                break;
            case 2:
                uiComponentList.forEach((action) => {
                    const occuranceIndex = apiComponentList.findIndex((item) => item.disputeType === this.props.disputeType && action.reason && !action.dataColumnKey && item.reason === action.reason);
                    if (occuranceIndex !== -1) {
                        let tempDataColumns = Object.assign([], action.dataColumns);
                        let index = 0;
                        tempDataColumns.forEach((dataColumn) => {
                            const dataColumnListIndex = apiComponentList[occuranceIndex].dataColumns?.findIndex((item) =>
                                item.displayType === 'DROPDOWN' && dataColumn.columnKey == item.columnKey && item.list.length > 0);
                            if (dataColumnListIndex !== -1) {

                                apiComponentList[occuranceIndex].dataColumns[dataColumnListIndex].list = this.getResponseReasonFilteredByReasonCodeLevelTwo(apiComponentList,occuranceIndex,dataColumnListIndex)

                                tempDataColumns[index].list = apiComponentList[occuranceIndex].dataColumns[dataColumnListIndex].list;
                            }
                            index++;
                        })
                        action.dataColumns = [...tempDataColumns];
                        filteredComponents = filteredComponents.concat(action);
                    }
                });
                this.setState({
                    levelTwoComponents: filteredComponents,
                })
                break;
            case 3:
                uiComponentList.forEach((action) => {
                    const occuranceIndex = apiComponentList.findIndex((item) =>
                        item.disputeType === this.props.disputeType && action.reason && action.dataColumnKey && item.reason === action.reason && item.dataColumnKey === action.dataColumnKey
                    );
                    if (occuranceIndex !== -1) {
                        let tempDataColumns = Object.assign([], action.dataColumns);
                        let index = 0;
                        tempDataColumns.forEach((dataColumn) => {
                            const dataColumnListIndex = apiComponentList[occuranceIndex].dataColumns?.findIndex((item) =>
                                item.displayType === 'DROPDOWN' && dataColumn.columnKey == item.columnKey && item.list.length > 0
                            );
                            if (dataColumnListIndex !== -1) {
                                tempDataColumns[index].list = apiComponentList[occuranceIndex].dataColumns[dataColumnListIndex].list;
                            }
                            index++;
                        });
                        action.dataColumns = [...tempDataColumns];
                        filteredComponents = filteredComponents.concat(action);
                    }
                });
                this.setState({
                    levelThreeComponents: filteredComponents,
                })
                break;
        }

        return filteredComponents;
    }

    getComponentList = (apiComponentList) => {
        if (((this.props.reasonCode == __REASON_CODE_101__ || this.props.reasonCode == __REASON_CODE_103__)
            && this.props.merchantCurrencyCode !== undefined && this.props.merchantCurrencyCode == 'USD'
            && this.props.foreignDomesticIndicator !== undefined && this.props.foreignDomesticIndicator == 'D') ||
            (this.props.reasonCode == __REASON_CODE_104__ || this.props.reasonCode == __REASON_CODE_102__)) {
            return apiComponentList;
        } else if (apiComponentList[0].disputeType == 'Allocation') {
            let apiComponentListCopy = [...apiComponentList];
            apiComponentListCopy[0].dataColumns[0].list = apiComponentListCopy[0].dataColumns[0].list.filter((item) => item.value != 'CE');
            return apiComponentListCopy;
        }
    }

    //Set different component levels
    setDifferentComponentLevels() {
        this.setState({
            isLevelOneLoading: true,
            isLevelTwoLoading: true,
            isLevelThreeLoading: true,
            autoPopulateDetailsLoading: true,
        })
        fetchLevelOneQuestionnaireComponents(this.props.reasonCode).then((response) => {
            this.filterQuestionnaireComponentWithAPIs(response.data, getLevelOneComponents()[this.props.cardBrand], 1);
            this.setState({
                isLevelOneLoading: false,
            })
        }).catch((error) => {
            this.setState({
                isLevelOneLoading: false,
            })
            console.log('Unable to fetch levelOne questionnaire data', error);
        });
        fetchLevelTwoQuestionnaireComponents(this.props.reasonCode, this.props.reasonCodeCategory).then((response) => {
            this.filterQuestionnaireComponentWithAPIs(response.data, getLevelTwoComponents()[this.props.cardBrand], 2);
            this.setState({
                isLevelTwoLoading: false,
            })
        }).catch((error) => {
            this.setState({
                isLevelTwoLoading: false,
            })
            console.log('Unable to fetch levelTwo questionnaire data', error);
        });
        // Moved this method in another method - getLevelThreeComponents
        // fetchLevelThreeQuestionnaireComponents().then((response) => {
        //     this.filterQuestionnaireComponentWithAPIs(response.data, getLevelThreeComponents()[this.props.cardBrand], 3);
        //     this.setState({
        //         isLevelThreeLoading: false,
        //     })
        // }).catch((error) => {
        //     this.setState({
        //         isLevelThreeLoading: false,
        //     })
        //     console.log('Unable to fetch levelThree questionnaire data', error);
        // });
        let caseNumber = '';
        const __CASELANDING_PATH__ = "caselanding/";
        if (window.location.href.indexOf(__CASELANDING_PATH__) != -1) {
            let pathArray = window.location.href.split(__CASELANDING_PATH__);
            if (pathArray.length == 2)
                caseNumber = pathArray[1]?.split("?")[0];
        }
        getQuestionnaireAutoPopulateDetails(caseNumber).then((response) => {
            this.setState({
                autoPopulateDetails: response.data,
                autoPopulateDetailsLoading: false,
            }, () => {
                this.getLevelThreeComponents()
            })
        }).catch((error) => {
            this.setState({
                autoPopulateDetailsLoading: false,
            }, () => {
                this.getLevelThreeComponents()
            })
            console.log('Unable to fetch auto Populate Details for questionnaire data', error);
        });

    }

    getLevelThreeComponents = () => {
        fetchLevelThreeQuestionnaireComponents().then((response) => {
            this.filterQuestionnaireComponentWithAPIs(response.data, getLevelThreeComponents(this.state.autoPopulateDetails)[this.props.cardBrand], 3);
            this.setState({
                isLevelThreeLoading: false,
            })
        }).catch((error) => {
            this.setState({
                isLevelThreeLoading: false,
            })
            console.log('Unable to fetch levelThree questionnaire data', error);
        });

    }

    renderResponseBanner(title, description) {
        return (
            <div>
                 <ImagePortal>
                <ResponseBanner
                    titleStyle={{ color: 'light-green' }}
                    descriptionStyle={{ color: 'grey' }}
                    valueStyle={{ color: 'black' }}
                    title={title}
                    description={description}
                    type="danger"
                    onClose={this.onCloseDocIndicator}
                    cancelOnly
                    cancelButtonText="DISMISS"
                    primaryButtonActionValue=""
                />
                </ImagePortal>
            </div>
        );
    }
    renderInvalidSelectionResponseBanner() {
        let description = `Please select valid option for reason code: `;
        const descriptionHtml = (
            <div>
                {description}
                <b>
                    {this.props.reasonCode}
                </b>
            </div>);
        return (
            <div>
                <ImagePortal>
                <ResponseBanner
                    titleStyle={{ color: 'light-green' }}
                    descriptionStyle={{ color: 'grey' }}
                    valueStyle={{ color: 'black' }}
                    title='Invalid Selection'
                    descriptionHtml={descriptionHtml}
                    type="danger"
                    onClose={this.onCloseDocIndicator}
                    cancelOnly
                    cancelButtonText="DISMISS"
                    primaryButtonActionValue=""
                />
                </ImagePortal>
            </div>
        );
    }

    onCloseDocIndicator() {
        this.setState({ showDocIndBanner: false, isInvalidSelection: false });
    }

    performLevelThreeValidations(dataColumns) {
        if (this.props.disputeType === __ALLOCATION__) {
            if (dataColumns.length > 1 && dataColumns[1].selectedOption) {
                switch (dataColumns[1].selectedOption.value) {
                    case __IDRA4__:
                        dataColumns.length > 4 && dataColumns[2].value && dataColumns[3].value && dataColumns[3].value.trim() !== '' && dataColumns[4].value && dataColumns[4].value.trim() !== '' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        break;
                    case __CP01__:
                        let patternACp01Arn = new RegExp(dataColumns[2].regex);
                        dataColumns.length > 4 && dataColumns[2].value && patternACp01Arn.test(dataColumns[2].value) && dataColumns[2].value.trim() !== '' && dataColumns[3].value && dataColumns[3].value.trim() !== '' && !dataColumns[3]?.errorMsg && dataColumns[4].value ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        break;
                    case __IDRA1__: case __IDRA2__: case __IDRA3__:
                        let isValid = true;
                        if (dataColumns.length > 3 && dataColumns[2].value !== undefined && dataColumns[3].value !== undefined) {
                            moment(dataColumns[3].value).isSameOrAfter(dataColumns[2].value) ? isValid = true : isValid = false;
                            if (isValid) {
                                this.props.onDisableNextStep(false);
                            } else {
                                this.setState({
                                    showDocIndBanner: true,
                                    bannerTitle: 'Please select valid values in the displayed fields.',
                                    bannerDesc: 'Please select valid values in the displayed fields.',
                                });
                                this.props.onDisableNextStep(true);
                            }
                        }
                        break;
                    case __CP02__:
                        dataColumns.length > 3 && dataColumns[2].value && dataColumns[2].value.trim() !== '' && dataColumns[3].value && dataColumns[3].value.trim() !== '' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        break;
                    case __IDRA5__:
                        dataColumns.length > 2 && dataColumns[2].value ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        break;
                    case __IDRA6__: case __IDRA7__:
                        dataColumns.length > 2 && dataColumns[2].value && this.nextButtonForIDRA6andIDRA7(dataColumns[3].value) ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        break;
                    case __CE03__:
                        dataColumns.length > 11 && this.props.docInd != '0' && dataColumns[dataColumns.length - 1].isChecked ?
                            this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        break;
                    case __CE04__:

                        this.validateCE04(dataColumns, __ALLOCATION__) && this.props.docInd != '0' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        break;
                    case __CE09__:
                        let firstThree = false;
                        let selectedCheckboxes = [];
                        let filteredCheckboxes = dataColumns.filter(column => column.columnKey != __ace09EvidenceSameDevice__);
                        filteredCheckboxes.filter(column => column.columnKey != __idCollaborationCheckbox__).forEach(dataColumn => dataColumn.isChecked ? selectedCheckboxes.push(dataColumn) : null);
                        if (dataColumns[2].isChecked) {
                            dataColumns.length > 5 && dataColumns[3].value && !dataColumns[3]?.errorMsg && dataColumns[4].value && !dataColumns[4]?.errorMsg && dataColumns[5].value &&
                                dataColumns[3].value.trim() !== '' && dataColumns[4].value.trim() !== '' ? firstThree = true : firstThree = false;
                            firstThree && selectedCheckboxes.length >= 3 && dataColumns[dataColumns.length - 1].isChecked && this.props.docInd != '0' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        } else {
                            selectedCheckboxes.length >= 3 && dataColumns[dataColumns.length - 1].isChecked && this.props.docInd != '0' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        }
                        break;
                    case __CE13__:
                        dataColumns.length > 4 && dataColumns[2].isChecked && dataColumns[3].value && !dataColumns[3]?.errorMsg && dataColumns[5].value &&
                            dataColumns[3].value.trim() !== '' && dataColumns[4].value && dataColumns[4].value.trim() !== '' && !dataColumns[4]?.errorMsg && dataColumns[dataColumns.length - 1].isChecked && this.props.docInd != '0' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);  
                        break;
                    case __CE16__:
                        dataColumns.length > 3 && dataColumns[2].value && dataColumns[2].value.trim() !== "" &&  dataColumns[3].value &&  dataColumns[3].value.trim() !== ""  && dataColumns[5].isChecked  ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);  
                        break;    
                    default:
                        if (dataColumns[1].selectedOption.value.includes(__CE_COMPELLING_EVIDENCE__)) {
                            dataColumns[1].selectedOption.value && dataColumns[dataColumns.length - 1].isChecked && this.props.docInd != '0' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        } else {
                            dataColumns[1].selectedOption.value ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        }
                        break;
                }
            } else if (dataColumns[0].selectedOption && dataColumns[0].selectedOption.value == __ND_CARDHOLDER_NO_LONGER_DISPUTES__ || dataColumns[0].selectedOption.value == __EVIDENCE_OF_IMPRINT__ || dataColumns[0].selectedOption.value == __DC_DELAYED_CHARGE_TRANSACTION__) {
                dataColumns.length > 1 && dataColumns[dataColumns.length - 1].isChecked ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
            } else {
                dataColumns.length > 1 && dataColumns[1].selectedOption ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
            }
        } else if (this.props.disputeType === __COLLABORATION__) {
            if (dataColumns.length > 2 && dataColumns[2].selectedOption) {
                switch (dataColumns[2].selectedOption.value) {
                    case __CE03__:
                        let levelThreeValidated, levelTwoValidated, levelOneValidated = false;
                        dataColumns && dataColumns.length > 11 ? levelThreeValidated = true : levelThreeValidated = false;
                        dataColumns && dataColumns[dataColumns.length - 1].isChecked ? levelTwoValidated = true : levelTwoValidated = false;
                        dataColumns && dataColumns.length > 1 && dataColumns[1].value && dataColumns[1].value.trim() !== '' ? levelOneValidated = true : levelOneValidated = false;
                        levelOneValidated && levelTwoValidated && levelThreeValidated && this.props.docInd != '0' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        break;
                    case __CE04__:
                        this.validateCE04(dataColumns, __COLLABORATION__) && this.props.docInd != '0' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        break;
                    case __CP01__:
                        let levelOneValidatedCP01, levelThreeValidatedCP01 = false;
                        dataColumns && dataColumns.length > 6 && dataColumns[3].value && dataColumns[4].value && dataColumns[5].value && dataColumns[6].value &&
                        dataColumns[3].value && dataColumns[3].value.trim() !== '' && !dataColumns[3]?.errorMsg && !dataColumns[5]?.errorMsg && dataColumns[5].value.trim() !== '' &&  dataColumns[6].value && dataColumns[6].value.trim() !== '' ? levelThreeValidatedCP01 = true : levelThreeValidatedCP01 = false;
                        dataColumns && dataColumns.length > 1 && dataColumns[1].value && dataColumns[1].value.trim() !== '' ? levelOneValidatedCP01 = true : levelOneValidatedCP01 = false;
                        levelOneValidatedCP01 && levelThreeValidatedCP01 ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        break;
                    case __CP02__:
                        dataColumns && dataColumns.length > 1 && dataColumns[1].value && dataColumns[3].value && dataColumns[4].value && dataColumns[5].value &&
                            dataColumns[1].value.trim() !== '' && dataColumns[3].value.trim() !== '' && dataColumns[4].value.trim() !== '' && dataColumns[5].value.trim() !== '' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        break;
                    case __IDRC3__:
                        const cancelIndex = dataColumns.findIndex((item) => item.displayType === __SINGLEDATE__ && item.columnKey === __colbCancellationDate__);
                        dataColumns.length > 2 && dataColumns[cancelIndex].value ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        break;
                    default:
                        if (dataColumns[2].selectedOption.value.includes(__CE_COMPELLING_EVIDENCE__)) {
                            dataColumns[1].value && dataColumns[1].value.trim() !== "" && dataColumns[dataColumns.length - 1].isChecked && this.props.docInd != '0' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        } else {
                            dataColumns[1].value && dataColumns[1].value.trim() !== "" ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        }
                        break;
                }
            } else if (dataColumns[0].selectedOption.value === __CDLT__ || dataColumns[0].selectedOption.value === __NL_NOT_LISTED_ABOVE__ || dataColumns[0].selectedOption.value === __CNLD_CARDHOLDER_NO_LONGER_DISPUTES__ || dataColumns[0].selectedOption.value === __ID_INVALID_DISUTE__ || dataColumns[0].selectedOption.value === __RM_REVERSAL_ISSUED_BY_MERCHANT__ 
                || dataColumns[0].selectedOption.value === __FC__ )
             {
                switch (dataColumns[0].selectedOption.value) {
                    case __CNLD_CARDHOLDER_NO_LONGER_DISPUTES__:
                        if (this.props.reasonCode == __REASON_CODE_131__ || this.props.reasonCode == __REASON_CODE_132__ || this.props.reasonCode == __REASON_CODE_133__ || this.props.reasonCode == __REASON_CODE_137__) {
                            dataColumns.length > 3 && dataColumns[2].value && dataColumns[1].value && dataColumns[1].value.trim() !== "" && dataColumns[2].value.trim() !== "" && this.props.docInd != '0' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        } else {
                            dataColumns.length > 3 && dataColumns[dataColumns.length - 1].isChecked && dataColumns[2].value && dataColumns[1].value && dataColumns[1].value.trim() !== "" && dataColumns[2].value.trim() !== "" && this.props.docInd != '0' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        }
                        break;
                    case __FC__ :
                            let levelOneValidation = dataColumns[1].value && dataColumns[2].value && dataColumns[3].value && dataColumns[5].isChecked ? true : false;
                        levelOneValidation ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true)
                        break;
                    case __ID_INVALID_DISUTE__:
                        let levelOneValidate = dataColumns[1].value ? true : false;
                        let firstLayer = false;
                        let secondLayer = false;
                        let complianceReasonCode = null;
                        if (this.props.reasonCode == __REASON_CODE_121__) {
                            const tranIndex = dataColumns.findIndex((item) => item.displayType === __SINGLEDATE__ && item.columnKey === __colbTransactionDate__);
                            dataColumns.length > 3 && dataColumns[tranIndex].value ? firstLayer = true : firstLayer = false;
                        } else if (this.props.reasonCode == __REASON_CODE_124__) {
                            const authIndex = dataColumns.findIndex((item) => item.displayType === __SINGLEDATE__ && item.columnKey === __colbAuthorizationDate__);
                            dataColumns.length > 2 && dataColumns[authIndex].value ? firstLayer = true : firstLayer = false;
                            complianceReasonCode = true;
                        } 
                        else if (this.props.reasonCode == __REASON_CODE_125__ || this.props.reasonCode == __REASON_CODE_126__ || this.props.reasonCode == __REASON_CODE_127__) {
                            firstLayer = true;
                            complianceReasonCode = true;
                        }
                        else {
                            firstLayer = true;
                        }
                        if (dataColumns.length > 4 ) {
                            if (dataColumns[4].selectedOption&&dataColumns[4].required && dataColumns[4].selectedOption.value === __IDRC3__) {
                            dataColumns.length > 8 && dataColumns[7].value && dataColumns[dataColumns.length - 1].isChecked ? secondLayer = true : secondLayer = false;
                            } else if ( dataColumns[4].selectedOption&&dataColumns[4].required && dataColumns[4].selectedOption.value === __IDRC25__) {
                            dataColumns.length > 8 && dataColumns[6].value && dataColumns[dataColumns.length - 1].isChecked ? secondLayer = true : secondLayer = false;
                            } else if((dataColumns[4].selectedOption && dataColumns[4].required)|| (!dataColumns[4].required&&!dataColumns[4].selectedOption)) {
                            dataColumns[dataColumns.length - 1].isChecked ? secondLayer = true : secondLayer = false;
                            }
                        }
                        if (complianceReasonCode !== null && complianceReasonCode === true) {
                            firstLayer && secondLayer && levelOneValidate && this.props.docInd != '0' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        } else {
                            firstLayer && levelOneValidate && this.props.docInd != '0' ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        }
                        break;
                    case __RM_REVERSAL_ISSUED_BY_MERCHANT__:
                        dataColumns.length > 2 && dataColumns[1].value && dataColumns[2].value && dataColumns[1].value.trim() !== "" && dataColumns[2].value.trim() !== "" ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        break;
                    case __CDLT__:
                        dataColumns.length > 3 && dataColumns[dataColumns.length - 1].isChecked && dataColumns[1].value && dataColumns[1].value.trim() !== "" && dataColumns[2].value && dataColumns[2].value.trim() !== "" ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        break;
                    case __NL_NOT_LISTED_ABOVE__:
                        if (this.props.reasonCode == __REASON_CODE_131__ || this.props.reasonCode == __REASON_CODE_132__ || this.props.reasonCode == __REASON_CODE_133__ || this.props.reasonCode == __REASON_CODE_137__) {
                            dataColumns.length > 3 && dataColumns[1].value && dataColumns[1].value.trim() !== "" && dataColumns[2].value && dataColumns[2].value.trim() !== "" ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        }
                        else {
                            dataColumns.length > 3 && dataColumns[dataColumns.length - 1].isChecked && dataColumns[1].value && dataColumns[1].value.trim() !== "" && dataColumns[2].value && dataColumns[2].value.trim() !== "" ? this.props.onDisableNextStep(false) : this.props.onDisableNextStep(true);
                        }
                        break;
                    
                }
            }
        }
    }


    nextButtonForIDRA6andIDRA7(value){
       return this.props.reasonCode === __REASON_CODE_113__? !!value : true;
    }


    validateCE04(dataColumns, disputeType) {
        let isValid = false;
        let isMandate1 = false;
        let isMandate2 = false;
        let isMandate3 = false;
        let isNotMandate =false;
        if (disputeType === __ALLOCATION__) {
            let firstThreeValidated = false;
            let validated = true;
            let selectedColumns = [];
            let index1, index2, index3 = -1;
            index1 = dataColumns.findIndex(item => item.columnKey === __ace04DescDownloaded__);
            index2 = dataColumns.findIndex(item => item.columnKey === __ace04DownloadDate__);
            if (index1 > -1 && index2 > -1) {
                dataColumns[index1].value && dataColumns[index2].value &&
                    dataColumns[index1].value.trim() !== '' ? firstThreeValidated = true : firstThreeValidated = false;
            }
            dataColumns.filter(item => item.columnKey != __idCollaborationCheckbox__).forEach(dataColumn => dataColumn.isChecked ? selectedColumns.push(dataColumn) : null);
            selectedColumns.forEach(column => {
                switch (column.columnKey) {
                    case __ace04ProofWebAccess__:
                        index1 = dataColumns.findIndex(item => item.columnKey === __ace04DescProof__);
                        index1 > -1 && dataColumns[index1].value && dataColumns[index1].value.trim() !== '' ? column.validated = true : column.validated = false;
                        isMandate1 = column.validated;
                        break;
                    case __ace04EvidenceWebAccess__:
                        index1 = dataColumns.findIndex(item => item.columnKey === __ace04DescEvid__);
                        index1 > -1 && dataColumns[index1].value && dataColumns[index1].value.trim() !== '' ? column.validated = true : column.validated = false;
                        isMandate2 = column.validated;
                        break;
                    case __ace04EvidenceSameDevice__:
                        index1 = dataColumns.findIndex(item => item.columnKey === __ace04ARN__);
                        index2 = dataColumns.findIndex(item => item.columnKey === __ace04TransacAmount__);
                        index3 = dataColumns.findIndex(item => item.columnKey === __ace04TranDate__);
                        if (index1 > -1 && index2 > -1 && index3 > -1) {
                            dataColumns[index1].value && dataColumns[index2].value && dataColumns[index3].value && !dataColumns[index1]?.errorMsg && !dataColumns[index2]?.errorMsg &&
                                dataColumns[index1].value.trim() !== '' && dataColumns[index2].value.trim() !== '' && dataColumns[index3].value ? column.validated = true : column.validated = false;
                        }
                        isMandate3 = column.validated;
                        break;
                    case __ace04PurchaserIp__:
                        index1 = dataColumns.findIndex(item => item.columnKey === __ace04GeoLocation__);
                        index2 = dataColumns.findIndex(item => item.columnKey === __ace04GeoPurcheserIP__);
                        if (index1 > -1 && index2 > -1) {
                            dataColumns[index1].value && dataColumns[index2].value &&
                                dataColumns[index1].value.trim() !== '' && dataColumns[index2].value.trim() !== '' ? column.validated = true : column.validated = false;
                        }
                        isNotMandate =column.validated;
                        break;
                    case __ace04PurchaserName__:
                        index1 = dataColumns.findIndex(item => item.columnKey === __ace04PurchasrEmail__);
                        index2 = dataColumns.findIndex(item => item.columnKey === __ace04PurchasrName__);
                        if (index1 > -1 && index2 > -1) {
                            dataColumns[index1].value && dataColumns[index2].value &&
                                dataColumns[index1].value.trim() !== '' && dataColumns[index2].value.trim() !== '' ? column.validated = true : column.validated = false;
                        }
                        isNotMandate =column.validated;
                        break;
                    case __ace04DeviceIDName__:
                        index1 = dataColumns.findIndex(item => item.columnKey === __ace04DevId__);
                        index2 = dataColumns.findIndex(item => item.columnKey === __ace04DeviceName__);
                        if (index1 > -1 && index2 > -1) {
                            dataColumns[index1].value && dataColumns[index2].value &&
                                dataColumns[index1].value.trim() !== '' && dataColumns[index2].value.trim() !== '' ? column.validated = true : column.validated = false;
                        }
                        isNotMandate =column.validated;
                        break;
                }
            });
            selectedColumns.forEach(column => {
                if (!column.validated) {
                    validated = false;
                }
            });
           (((firstThreeValidated && validated && isNotMandate && !(isMandate1 || isMandate2 || isMandate3)) || (firstThreeValidated && validated && (isMandate1 || isMandate2 || isMandate3) && dataColumns[dataColumns.length - 1].isChecked)) && selectedColumns.length >= 2) ? isValid = true : isValid = false;
        } else if (disputeType === __COLLABORATION__) {
            let selectedColumns = [];
            let index1, index2, index3 = -1;
            let validated = true;
            let firstThreeValidatedCE04, levelOneValidatedCE04, levelTwoValidatedCE04, levelThreeValidatedCE04 = false;

            index1 = dataColumns.findIndex(item => item.columnKey === __cce04DescDownloaded__);
            index2 = dataColumns.findIndex(item => item.columnKey === __cce04DownloadDate__);
            if (index1 > -1 && index2 > -1) {
                dataColumns[index1].value && dataColumns[index2].value &&
                    dataColumns[index1].value.trim() !== '' ? firstThreeValidatedCE04 = true : firstThreeValidatedCE04 = false;
            }
            dataColumns.filter(item => item.columnKey != __idCollaborationCheckbox__).forEach(dataColumn => dataColumn.isChecked ? selectedColumns.push(dataColumn) : null);
            selectedColumns.forEach(column => {
                switch (column.columnKey) {
                    case __cce04ProofWebAccess__:
                        index1 = dataColumns.findIndex(item => item.columnKey === __cce04DescProof__);
                        index1 > -1 && dataColumns[index1].value && dataColumns[index1].value.trim() !== '' ? column.validated = true : column.validated = false;
                        isMandate1 = column.validated;
                        break;
                    case __cce04EvidenceWebAccess__:
                        index1 = dataColumns.findIndex(item => item.columnKey === __cce04DescEvid__);
                        index1 > -1 && dataColumns[index1].value && dataColumns[index1].value.trim() !== '' ? column.validated = true : column.validated = false;
                        isMandate2 = column.validated;
                        break;
                    case __cce04EvidenceSameDevice__:
                        index1 = dataColumns.findIndex(item => item.columnKey === __cce04ARN__);
                        index2 = dataColumns.findIndex(item => item.columnKey === __cce04TransacAmount__);
                        index3 = dataColumns.findIndex(item => item.columnKey === __cce04TranDate__);
                        if (index1 > -1 && index2 > -1 && index3 > -1) {
                            dataColumns[index1].value && dataColumns[index2].value && dataColumns[index3].value &&  !dataColumns[index1]?.errorMsg && !dataColumns[index2]?.errorMsg &&
                                dataColumns[index1].value.trim() !== '' && dataColumns[index2].value.trim() !== '' ? column.validated = true : column.validated = false;
                        }
                        isMandate3 = column.validated;
                        break;
                    case __cce04PurchaserIp__:
                        index1 = dataColumns.findIndex(item => item.columnKey === __cce04GeoLocation__);
                        index2 = dataColumns.findIndex(item => item.columnKey === __cce04GeoPurcheserIP__);
                        if (index1 > -1 && index2 > -1) {
                            dataColumns[index1].value && dataColumns[index2].value &&
                                dataColumns[index1].value.trim() !== '' && dataColumns[index2].value.trim() !== '' ? column.validated = true : column.validated = false;
                        }
                        isNotMandate =column.validated;
                        break;
                    case __cce04PurchaserName__:
                        index1 = dataColumns.findIndex(item => item.columnKey === __cce04PurchasrEmail__);
                        index2 = dataColumns.findIndex(item => item.columnKey === __cce04PurchasrName__);
                        if (index1 > -1 && index2 > -1) {
                            dataColumns[index1].value && dataColumns[index2].value &&
                                dataColumns[index1].value.trim() !== '' && dataColumns[index2].value.trim() !== '' ? column.validated = true : column.validated = false;
                        }
                        isNotMandate =column.validated;
                        break;
                    case __cce04DeviceIDName__:
                        index1 = dataColumns.findIndex(item => item.columnKey === __cce04DevId__);
                        index2 = dataColumns.findIndex(item => item.columnKey === __cce04DeviceName__);
                        if (index1 > -1 && index2 > -1) {
                            dataColumns[index1].value && dataColumns[index2].value &&
                                dataColumns[index1].value.trim() !== '' && dataColumns[index2].value.trim() !== '' ? column.validated = true : column.validated = false;
                        }
                        isNotMandate =column.validated;
                        break;
                }
            });
            selectedColumns.forEach(column => {
                if (!column.validated) {
                    validated = false;
                }
            });
            //firstThreeValidatedCE04 && validated && selectedColumns.length >= 2 ? levelThreeValidatedCE04 = true : levelThreeValidatedCE04 = false;
           // dataColumns.length > 3 && dataColumns[dataColumns.length - 1].isChecked ? levelTwoValidatedCE04 = true : levelTwoValidatedCE04 = false;
           // dataColumns.length > 1 && dataColumns[1].value && dataColumns[1].value.trim() !== '' ? levelOneValidatedCE04 = true : levelOneValidatedCE04 = false;
           //levelOneValidatedCE04 && levelTwoValidatedCE04 && levelThreeValidatedCE04 ? isValid = true : isValid = false;
           (((firstThreeValidatedCE04 && validated && isNotMandate && !(isMandate1 || isMandate2 || isMandate3)) || (firstThreeValidatedCE04 && validated && (isMandate1 || isMandate2 || isMandate3) && dataColumns[dataColumns.length - 1].isChecked)) && selectedColumns.length >= 2)? isValid = true : isValid = false;
        }
        return isValid;
    }

    performLevelTwoPreValidations() {
        let levelTwoComponents = this.state.levelTwoComponents;
        let levelTwoComponentsEURegion = null;
        levelTwoComponents.forEach(levelTwoComponent => {
            switch (this.props.reasonCode.trim()) {
                case __REASON_CODE_101__:
                case __REASON_CODE_103__:
                case __REASON_CODE_104__:
                    if (levelTwoComponent.disputeType === __ALLOCATION__ && levelTwoComponent.reason === "CE" && this.props.merchantRegionCode !== 'EU' && this.props.cardBrand === 'VISA' ) {
                        levelTwoComponentsEURegion =  levelTwoComponent.dataColumns[0] && levelTwoComponent.dataColumns[0].list.filter(eachCol=>{
                            return eachCol.value !== 'CE12' && eachCol.value !== 'CE15'
                        })
                         levelTwoComponent.dataColumns[0].list = levelTwoComponentsEURegion;
                    }         
                break;
                case __REASON_CODE_121__:
                    if (levelTwoComponent.disputeType === __COLLABORATION__ && levelTwoComponent.reason === __ID_INVALID_DISUTE__) {
                        levelTwoComponent.dataColumns[1].required = true;
                        levelTwoComponent.dataColumns[1].name = 'Correct Transaction Date (required)';
                        levelTwoComponent.dataColumns[2].required = false;
                        levelTwoComponent.dataColumns[2].hidden = true;
                        break;
                    }
                case __REASON_CODE_124__:
                    if (levelTwoComponent.disputeType === __COLLABORATION__ && levelTwoComponent.reason === __ID_INVALID_DISUTE__) {
                        levelTwoComponent.dataColumns[0].required = true;
                        levelTwoComponent.dataColumns[0].name = 'Authorization Date (required)';
                        levelTwoComponent.dataColumns[2].required = false;
                        levelTwoComponent.dataColumns[2].hidden = true;
                        break;
                    }
            }
        });
        return levelTwoComponents;
    }

    // This method is responsible for select input changes
    onSelectionChange(option) {
        let dataColumns = Object.assign([], this.state.dataColumns);
        let dropDownIndex = -1;
        var selectedOption = null;
        this.setState({
            isInvalidSelection: false,
        })
        for (let i = __INDEX_ZERO__; i < dataColumns.length; i++) {
            if (dataColumns.filter((dataColumn) => dataColumn.displayType === __DROP_DOWN__) && dataColumns[i].list && dataColumns[i].list.findIndex((item) => item.value === option) > -1) {
                selectedOption = option.value == undefined ? dataColumns[i].list.find((item) => item.value === option) : dataColumns[i].list.find((item) => item.value === option);
                dropDownIndex = i;
                break;
            }
        }
        if (dataColumns[dropDownIndex].selectedOption !== selectedOption && this.performLevelOneValidation(selectedOption)) {
            dataColumns[dropDownIndex].selectedOption = selectedOption;
            //Check if the option is present on level one dropdown then set level tow data here
            dataColumns = this.setComponentForDifferentLevels(option, dropDownIndex, selectedOption, dataColumns);
            if (!(option === __CDLT__ || option === __CE_COMPELLING_EVIDENCE__ ||
                option === __CNLD_CARDHOLDER_NO_LONGER_DISPUTES__ || option === __ID_INVALID_DISUTE__ ||
                option === __RM_REVERSAL_ISSUED_BY_MERCHANT__ || option === __CP_CREDIT_OR_REVERSAL_PROCESSED__ || option === __NL_NOT_LISTED_ABOVE__)) {
                this.performLevelThreeValidations(dataColumns);
                this.setQuestionnaireReviewData(dataColumns);
            }

            if (option === __ID_INVALID_DISUTE__ && this.props.disputeType === __COLLABORATION__ && this.props.reasonCode &&
                !(this.props.reasonCode == __REASON_CODE_121__ || this.props.reasonCode == __REASON_CODE_124__)) {
                //For ID and reason code other that 12.1, 12.4 Tran, Auth and Cancelation Date not is not required
                const tranDateIndex = dataColumns.findIndex((item) => item.displayType === __SINGLEDATE__ && item.columnKey === __colbTransactionDate__);
                dataColumns.splice(tranDateIndex, 1);
                const authDateIndex = dataColumns.findIndex((item) => item.displayType === __SINGLEDATE__ && item.columnKey === __colbAuthorizationDate__);
                dataColumns.splice(authDateIndex, 1);
                const cancelDateIndex = dataColumns.findIndex((item) => item.displayType === __SINGLEDATE__ && item.columnKey === __colbCancellationDate__);
                dataColumns.splice(cancelDateIndex, 1);
            }

            if (option === __ID_INVALID_DISUTE__ && this.props.disputeType === __COLLABORATION__ && this.props.reasonCode && this.props.reasonCode == __REASON_CODE_121__) {
                //For ID 12.1 Only Tran date is required
                const authDateIndex = dataColumns.findIndex((item) => item.displayType === __SINGLEDATE__ && item.columnKey === __colbAuthorizationDate__);
                dataColumns.splice(authDateIndex, 1);
                const cancelDateIndex = dataColumns.findIndex((item) => item.displayType === __SINGLEDATE__ && item.columnKey === __colbCancellationDate__);
                dataColumns.splice(cancelDateIndex, 1);
            }

            if (option === __ID_INVALID_DISUTE__ && this.props.disputeType === __COLLABORATION__ && this.props.reasonCode && this.props.reasonCode == __REASON_CODE_124__) {
                //For ID 12.4 Only Auth date is required
                const tranDateIndex = dataColumns.findIndex((item) => item.displayType === __SINGLEDATE__ && item.columnKey === __colbTransactionDate__);
                dataColumns.splice(tranDateIndex, 1);
                const cancelDateIndex = dataColumns.findIndex((item) => item.displayType === __SINGLEDATE__ && item.columnKey === __colbCancellationDate__);
                dataColumns.splice(cancelDateIndex, 1);
            }

            if (option === __ID_INVALID_DISUTE__ && this.props.disputeType === __COLLABORATION__ && this.props.reasonCode && this.props.reasonCode == __REASON_CODE_125__) {
                //For ID 12.5 invalidDisputeReason dropdown is not required
                const invalidDisputeIndex = dataColumns.findIndex((item) => item.displayType === __DROPDOWN__ && item.columnKey === __INVALID_DISPUTE_REASON__);
                dataColumns.splice(invalidDisputeIndex, 1);
            }

        } else if (!this.performLevelOneValidation(selectedOption)) {
            this.setState({
                isInvalidSelection: true,
            })
        }
    }

    performLevelOneValidation(option) {
        if (this.props.disputeType === __ALLOCATION__) {
            switch (option.value) {
                case __CE_COMPELLING_EVIDENCE__:
                    /*NOTE : As per US244395,CE is enabled for 10.1 & 10.3 */
                    if (this.props.reasonCode && (this.props.reasonCode == __REASON_CODE_101__)) {
                        return true;
                    }else if (this.props.reasonCode && (this.props.reasonCode == __REASON_CODE_103__)) {
                        return true;
                    }else if (this.props.reasonCode && (this.props.reasonCode == __REASON_CODE_104__)) {
                        return true;
                    }else{ return false}
                case __ND_CARDHOLDER_NO_LONGER_DISPUTES__:
                       if (this.props.reasonCode && (this.props.reasonCode == __REASON_CODE_111__)) {
                           return false;
                       } else if (this.props.reasonCode && (this.props.reasonCode == __REASON_CODE_112__)) {
                           return false;
                       } else if (this.props.reasonCode && (this.props.reasonCode == __REASON_CODE_113__)) {
                           return false;
                       }
                       else {
                           return true;
                    }
                case __DC_DELAYED_CHARGE_TRANSACTION__:
                    return (dcValidReasonCodes.includes(this.props.reasonCode));
            }
        } else if (this.props.disputeType === __COLLABORATION__) {
            switch (option.value) {
                case __CE_COMPELLING_EVIDENCE__:
                    /*NOTE : As per US244394,CE is disabled for 13.1 */
                    return false;
                 /*NOTE : As per US245172 ,CNLD & CP is disabled for 13.8 */
                case __CNLD_CARDHOLDER_NO_LONGER_DISPUTES__:
                    return this.props.reasonCode && this.props.reasonCode == __REASON_CODE_138__ ? false :true;
                case __CP_CREDIT_OR_REVERSAL_PROCESSED__:
                    return this.props.reasonCode && this.props.reasonCode == __REASON_CODE_138__ ? false :true;
                case __CDLT__:
                    return this.props.reasonCode && this.props.reasonCode == __REASON_CODE_139__ ? true : false;
                case __RM_REVERSAL_ISSUED_BY_MERCHANT__:
                    return this.props.reasonCode && (this.props.reasonCode == __REASON_CODE_138__ || this.props.reasonCode == __REASON_CODE_139__) ? true : false;
                case __FC__:
                    return this.props.reasonCode && (this.props.reasonCode == __REASON_CODE_131__ || this.props.reasonCode == __REASON_CODE_133__) ? true : false;

            }
        }
        return true;
    }
    
    setComponentForDifferentLevels(option, dropDownIndex, selectedOption, dataColumns) {
        if (option === __CDLT__ || option === __CE_COMPELLING_EVIDENCE__ || option === __ND_CARDHOLDER_NO_LONGER_DISPUTES__ ||
            option === __CNLD_CARDHOLDER_NO_LONGER_DISPUTES__ || option === __ID_INVALID_DISUTE__ || option === __FC__ ||
            option === __RM_REVERSAL_ISSUED_BY_MERCHANT__ || option === __EVIDENCE_OF_IMPRINT__ || option === __DC_DELAYED_CHARGE_TRANSACTION__|| option === __CP_CREDIT_OR_REVERSAL_PROCESSED__ || option === __NL_NOT_LISTED_ABOVE__) {

            let initialDataColumns = Object.assign([], this.state.initialDataColumns);
            initialDataColumns[dropDownIndex].selectedOption = selectedOption;
            let dataColumns = this.setLevelTwoComponents(initialDataColumns, option);
            return dataColumns;
        }
        else if (option.includes(__CE_COMPELLING_EVIDENCE__) || option.includes(__CP_CREDIT_OR_REVERSAL_PROCESSED__) ||
            option.includes(__ID_INVALID_DISUTE__)) {
            //Check if the option is present on level two then set level three data here
            return this.setLevelThreeComponents(dataColumns, option);
        }
        else {
            if (this.props.isDocChecked && !(["State", "Country", "Shipping Company Name"].includes(dataColumns[dropDownIndex]?.name))) {
                this.props.attachDocumentPage(this.props.issuerIndex, __POP__, __INDEX_ZERO__, this.props.issuerActionData);
            }
            this.setState({
                dataColumns,
            });
            let questionDataColumns = {
                dataColumns: dataColumns,
                initialDataColumns: this.state.initialDataColumns,
                prevLevelThreeDataColumns: this.state.prevLevelThreeDataColumns,
                attachArrayColumns: this.state.attachArrayColumns,
                levelTwoComponents: this.state.levelTwoComponents,
                levelThreeComponents: this.state.levelThreeComponents,
            }
            this.props.setQuestionnaireData(questionDataColumns);
            return dataColumns;
        }
    }

    /**
     * This method is responsible for setting level three components for the selected option of level two components
     * @param {Components to render on ui} dataColumns 
     * @param {selected option} option 
     */
    setLevelThreeComponents(dataColumns, option) {
        this.props.onDisableNextStep(true);
        let levelThreeComponents = this.state.levelThreeComponents;
        var selectedDataColumn;
        for (let i = __INDEX_ZERO__; i < levelThreeComponents.length; i++) {
            if (levelThreeComponents[i].disputeType === this.props.disputeType && levelThreeComponents[i].dataColumnKey === option) {
                selectedDataColumn = levelThreeComponents[i].dataColumns;
                break;
            }
        }
        this.addSecondaryColumns(dataColumns);
        return this.setSelectedDataColumns(selectedDataColumn, dataColumns);

    }

    setSelectedDataColumns(selectedDataColumn, dataColumns) {
        let checkBoxColumn;
        if (selectedDataColumn) {
            selectedDataColumn.map(dataColumn => {
                if (dataColumns.findIndex((item) => item.columnKey === dataColumn.columnKey) == -1 || dataColumn.displayType === 'LINE') {
                    dataColumn.value = dataColumn.value ? dataColumn.value : undefined;
                    dataColumn.length = 0;
                    dataColumn.className = dataColumn.displayType == 'TEXT'? 'text-input-questionnaire':'';
                    dataColumn.selectedOption = dataColumn.displayType === 'DROPDOWN' ? undefined : '';
                    if (dataColumn.displayType === 'CHECKBOX' && dataColumn.isChecked && item.type !== "attachDoc") {
                        dataColumn.isChecked = false;
                        let attachArray = dataColumn.attachArray;
                        attachArray && attachArray.forEach((attachComp) => {
                            attachComp.value = undefined;
                            attachComp.className = attachComp.displayType == 'TEXT'? 'text-input-questionnaire':'';
                        })
                        dataColumn.attachArray = attachArray;
                    }
                    dataColumns.push(dataColumn);
                }
            });


            let tempDataCols = Object.assign([], dataColumns);
            let tempIndex = 0;
            let attachCount = 0;
            tempDataCols.forEach((item) => {
                if (item.isChecked && item.displayType === 'CHECKBOX' && item.type !== "attachDoc" && item.attachArray) {
                    let attachArray = item.attachArray;
                    dataColumns.splice(attachCount + tempIndex + 1, __INDEX_ZERO__, ...attachArray);
                    attachCount += item.attachArray.length;
                }
                tempIndex++;
            })

        }
        // else if (this.props.isDocChecked && !selectedDataColumn) {
        //     this.props.attachDocumentPage(this.props.issuerIndex, __POP__, __INDEX_ZERO__);
        // }
        this.state.prevLevelThreeDataColumns && this.state.prevLevelThreeDataColumns.forEach((dataColumn) => {
            let prevColumnIndex = dataColumns.findIndex((item) => item.columnKey === dataColumn.columnKey);
            if (prevColumnIndex !== -1) {
                dataColumns.splice(prevColumnIndex, 1);
            } else if (dataColumn.displayType === 'CHECKBOX' && dataColumn.isChecked && dataColumn.attachArray) {
                dataColumn.attachArray.forEach((checkBoxComponent) => {
                    let checkBoxColumnIndex = dataColumns.findIndex((item) => item.columnKey === checkBoxComponent.columnKey);
                    if (checkBoxColumnIndex !== -1) {
                        dataColumns.splice(checkBoxColumnIndex, 1);
                    }
                });
            }
        });
        let attachCheckBoxIndex = dataColumns.findIndex((item) => item.displayType === 'CHECKBOX' && item.type == "attachDoc");
        if (attachCheckBoxIndex !== -1) {
            checkBoxColumn = Object.assign([], dataColumns[attachCheckBoxIndex]);
            dataColumns.splice(attachCheckBoxIndex, 1);
            if (!this.props.isDocChecked && checkBoxColumn.required) {
                checkBoxColumn.isChecked = true;
                this.props.attachDocumentPage(this.props.issuerIndex, __PUSH__, __INDEX_ZERO__, this.props.issuerActionData);
            }
        } else if ((this.props.isDocChecked && checkBoxColumn && !checkBoxColumn.isChecked) || (this.props.isDocChecked && !checkBoxColumn)) {
            this.props.attachDocumentPage(this.props.issuerIndex, __POP__, __INDEX_ZERO__, this.props.issuerActionData);
        }
        dataColumns.push(checkBoxColumn);
        dataColumns = dataColumns.filter(element => element !== undefined);
        this.setState({
            dataColumns,
            prevLevelThreeDataColumns: selectedDataColumn,
        });
        let questionDataColumns = {
            dataColumns: dataColumns,
            initialDataColumns: this.state.initialDataColumns,
            prevLevelThreeDataColumns: selectedDataColumn,
            attachArrayColumns: this.state.attachArrayColumns,
            levelTwoComponents: this.state.levelTwoComponents,
            levelThreeComponents: this.state.levelThreeComponents,
        }
        this.props.setQuestionnaireData(questionDataColumns);
        return dataColumns;
    }

    addSecondaryColumns(dataColumns) {
        if (this.state.prevLevelThreeDataColumns) {
            this.state.prevLevelThreeDataColumns.map(dataColumn => {
                let index = dataColumns.findIndex((item) => item.columnKey === dataColumn.columnKey);
                if (index !== -1) {
                    dataColumns.splice(index, 1);
                }
            });
        }
        if (this.state.attachArrayColumns) {
            this.state.attachArrayColumns.map(dataColumn => {
                let index = dataColumns.findIndex((item) => item.columnKey === dataColumn.columnKey);
                if (index !== -1) {
                    dataColumns.splice(index, 1);
                }
            });
        }
    }

    /**
     * This method is responsible for setting level two components for the selected option of level one components
     * @param {Components to render on ui} dataColumns 
     * @param {selected option} option 
     */
    setLevelTwoComponents(dataColumns, option) {
        let checkBoxColumn;
        this.props.onDisableNextStep(true);
        let validatedLevelTwoComponents = this.performLevelTwoPreValidations();
        var selectedDataColumn;
        for (let i = __INDEX_ZERO__; i < validatedLevelTwoComponents.length; i++) {
            if (validatedLevelTwoComponents[i].disputeType === this.props.disputeType && validatedLevelTwoComponents[i].reason === option) {
                selectedDataColumn = validatedLevelTwoComponents[i].dataColumns;
                break;
            }
        }
        if (selectedDataColumn) {
            selectedDataColumn.map(dataColumn => {
                if (dataColumns.findIndex((item) => item.columnKey === dataColumn.columnKey) == -1) {
                    dataColumn.value = undefined;
                    dataColumn.length = 0;
                    dataColumn.className = dataColumn.displayType == 'TEXT'? 'text-input-questionnaire':'';
                    dataColumn.selectedOption = dataColumn.displayType === 'DROPDOWN' ? undefined : '';
                    if (dataColumn.attachArray && dataColumn.displayType === 'CHECKBOX' && dataColumn.isChecked && item.type !== "attachDoc") {
                        dataColumn.isChecked = false;
                        let attachArray = dataColumn.attachArray;
                        attachArray.forEach((attachComp) => {
                            attachComp.value = undefined;
                            attachComp.className = attachComp.displayType == 'TEXT'? 'text-input-questionnaire':'';
                          })
                        dataColumn.attachArray = attachArray;
                    }
                    dataColumns.push(dataColumn);
                }

            });
        }
        let attachCheckBoxIndex = dataColumns.findIndex((item) => item.displayType === 'CHECKBOX' && item.type == "attachDoc");
        if (attachCheckBoxIndex !== -1) {
            checkBoxColumn = Object.assign([], dataColumns[attachCheckBoxIndex]);
            dataColumns.splice(attachCheckBoxIndex, 1);
            if (!this.props.isDocChecked && checkBoxColumn.required) {
                checkBoxColumn.isChecked = true;
                this.props.attachDocumentPage(this.props.issuerIndex, __PUSH__, __INDEX_ZERO__, this.props.issuerActionData);
            }
        } else if ((this.props.isDocChecked && checkBoxColumn && !checkBoxColumn.isChecked) || (this.props.isDocChecked && !checkBoxColumn)) {
            this.props.attachDocumentPage(this.props.issuerIndex, __POP__, __INDEX_ZERO__, this.props.issuerActionData);
        }
        dataColumns.push(checkBoxColumn);
        dataColumns = dataColumns.filter(element => element !== undefined);
        this.setState({
            dataColumns
        });
        let questionDataColumns = {
            dataColumns: dataColumns,
            initialDataColumns: this.state.initialDataColumns,
            prevLevelThreeDataColumns: this.state.prevLevelThreeDataColumns,
            attachArrayColumns: this.state.attachArrayColumns,
            levelTwoComponents: this.state.levelTwoComponents,
            levelThreeComponents: this.state.levelThreeComponents,
        }
        this.props.setQuestionnaireData(questionDataColumns);
        return dataColumns;
    }

    toggleCheckBoxes(dataColumnIndex) {
        let dataColumns = Object.assign([], this.state.dataColumns);
        let checkBoxColumn = dataColumns[dataColumnIndex];
        let attachArrayColumns = this.state.attachArrayColumns !== undefined ? Object.assign([], this.state.attachArrayColumns) : [];
        checkBoxColumn.isChecked = checkBoxColumn.isChecked ? !checkBoxColumn.isChecked : true;

        if (checkBoxColumn.type && checkBoxColumn.type === __ATTACH_DOCUMENT__) {
            if (checkBoxColumn.isChecked && !this.props.isDocChecked) {
                this.props.attachDocumentPage(this.props.issuerIndex, __PUSH__, __INDEX_ZERO__, this.props.issuerActionData);
            } else {
                this.props.attachDocumentPage(this.props.issuerIndex, __POP__, __INDEX_ZERO__, this.props.issuerActionData);
            }
        } 
        else if (checkBoxColumn.isChecked && checkBoxColumn.attachArray) {
            let attachArray = checkBoxColumn.attachArray;
            attachArray.forEach((attachComp) => {
                attachComp.value = undefined;
                attachComp.className = attachComp.displayType == 'TEXT'? 'text-input-questionnaire':'';
                if(attachComp?.errorMsg) {
                    attachComp.errorMsg = "";
                }
            })
            checkBoxColumn.attachArray = attachArray;
            dataColumns.splice(dataColumnIndex + 1, __INDEX_ZERO__, ...checkBoxColumn.attachArray);
            attachArrayColumns.splice(dataColumnIndex + 1, __INDEX_ZERO__, ...checkBoxColumn.attachArray);
            this.setState(
                {
                    dataColumns,
                    attachArrayColumns,
                },
            );
            let questionDataColumns = {
                dataColumns: dataColumns,
                initialDataColumns: this.state.initialDataColumns,
                prevLevelThreeDataColumns: this.state.prevLevelThreeDataColumns,
                attachArrayColumns: attachArrayColumns,
                levelTwoComponents: this.state.levelTwoComponents,
                levelThreeComponents: this.state.levelThreeComponents,
            }
            this.props.setQuestionnaireData(questionDataColumns);
        } else if (!checkBoxColumn.isChecked && checkBoxColumn.attachArray) {
            checkBoxColumn.attachArray.map(dataColumn => {
                if(dataColumn?.errorMsg) {
                    dataColumn.errorMsg = "";
                }
                let index = dataColumns.findIndex((item) => item.columnKey === dataColumn.columnKey);
                let attachArrayIndex = -1;
                if (this.state.attachArrayColumns) {
                    attachArrayIndex = this.state.attachArrayColumns.findIndex((item) => item.columnKey === dataColumn.columnKey);
                }
                if (index !== -1) {
                    dataColumns.splice(index, 1);
                }
                if (attachArrayIndex !== -1) {
                    attachArrayColumns.splice(index, 1);
                }
            })

            this.setState(
                {
                    dataColumns,
                    attachArrayColumns
                },

            );
            let questionDataColumns = {
                dataColumns: dataColumns,
                initialDataColumns: this.state.initialDataColumns,
                prevLevelThreeDataColumns: this.state.prevLevelThreeDataColumns,
                attachArrayColumns: attachArrayColumns,
                levelTwoComponents: this.state.levelTwoComponents,
                levelThreeComponents: this.state.levelThreeComponents,
            }
            this.props.setQuestionnaireData(questionDataColumns);
        } else {
            dataColumns[dataColumnIndex] = checkBoxColumn;
            this.setState(
                {
                    dataColumns,
                },

            );
            let questionDataColumns = {
                dataColumns: dataColumns,
                initialDataColumns: this.state.initialDataColumns,
                prevLevelThreeDataColumns: this.state.prevLevelThreeDataColumns,
                attachArrayColumns: attachArrayColumns,
                levelTwoComponents: this.state.levelTwoComponents,
                levelThreeComponents: this.state.levelThreeComponents,
            }
            this.props.setQuestionnaireData(questionDataColumns);
        }
        this.performLevelThreeValidations(dataColumns);
        this.setQuestionnaireReviewData(dataColumns);
    }

    handleInputToState = (index) => (event) => {
        let dataColumnsCopy = [...this.state.dataColumns];
        dataColumnsCopy[index].value = event.target.value;
        dataColumnsCopy[index].length = event.target.value.length;
        let patt = new RegExp(dataColumnsCopy[index].regex);
        if ((patt && !patt.test(dataColumnsCopy[index].value)) || dataColumnsCopy[index].required && (event.target.value.length == __INDEX_ZERO__ || !event.target.value.replace(/\s/g, '').length || event.target.value.length > dataColumnsCopy[index].textAreaMaxLength)) {
            dataColumnsCopy[index].className = dataColumnsCopy[index].displayType === 'TEXTAREA' ? 'input-text-area error-input-area' : 'error-input-area';
            if(dataColumnsCopy[index].validate && dataColumnsCopy[index].errorMsg){
                dataColumnsCopy[index].errorMsg = '';
            }
        } else if(dataColumnsCopy[index].validate){
            const errMsg = dataColumnsCopy[index].validate(dataColumnsCopy[index].value);
            if(!!errMsg) {
                dataColumnsCopy[index].errorMsg = errMsg;
                dataColumnsCopy[index].className = dataColumnsCopy[index].displayType === 'TEXTAREA' ? 'input-text-area error-input-area' : 'error-input-area';
            }
            else {
                dataColumnsCopy[index].errorMsg = '';
                dataColumnsCopy[index].className = dataColumnsCopy[index].displayType === 'TEXTAREA' ? 'input-text-area valid-input-area' : 'valid-input-area';
            }            
        } else {
            dataColumnsCopy[index].className = dataColumnsCopy[index].displayType === 'TEXTAREA' ? 'input-text-area valid-input-area' : 'valid-input-area';
        }
        this.performLevelThreeValidations(dataColumnsCopy);
        this.setQuestionnaireReviewData(dataColumnsCopy);
        this.setState({
            dataColumns: dataColumnsCopy
        });
    }
    handleInputToStateValidate = (index,isCurrency) => (event) => {/**ADDED for CURRENCY ,Refactor Pending */
        let dataColumns = Object.assign([], this.state.dataColumns);
        dataColumns[index].value = event.target.value && event.target.value.length <4 ? event.target.value.toUpperCase() :'';
        dataColumns[index].length = event.target.value.length <= 3 ? event.target.value.length :0;
        let patt = new RegExp(dataColumns[index].regex);
        if ((patt && !patt.test(dataColumns[index].value)) || dataColumns[index].required && (event.target.value.length == __INDEX_ZERO__ || !event.target.value.replace(/\s/g, '').length || event.target.value.length > dataColumns[index].textAreaMaxLength)) {
            dataColumns[index].className = dataColumns[index].displayType === 'TEXTAREA' ? 'input-text-area error-input-area' : 'error-input-area';
        } else {
            dataColumns[index].className = dataColumns[index].displayType === 'TEXTAREA' ? 'input-text-area valid-input-area' : 'valid-input-area';
        }
        if(isCurrency){

        }
        this.performLevelThreeValidations(dataColumns);
        this.setQuestionnaireReviewData(dataColumns);
        this.setState(
            {
                dataColumns,
            },
        );
    }
    
    onTimeChange(time, timeString, dataColumnIndex) {
        let newDataColumns = this.state.dataColumns;
        newDataColumns[dataColumnIndex].value = time;
        this.performLevelThreeValidations(newDataColumns);
        this.setQuestionnaireReviewData(newDataColumns);
        this.setState({
            dataColumns: newDataColumns,
        });
    }

    onSingleDateChange(dataColumnIndex, date) {
        let newDataColumns = this.state.dataColumns;
        newDataColumns[dataColumnIndex].value = date;
        this.performLevelThreeValidations(newDataColumns);
        this.setQuestionnaireReviewData(newDataColumns);
        this.setState({
            dataColumns: newDataColumns,
        });
    }

    setQuestionnaireReviewData(dataColumns) {
        let selectedOptions = ['Selected Option One', 'Selected Option Two', 'Selected Option Three', 'Selected Option Four', 'Selected Option Five', 'Selected Option Six'];
        let visaQnReviewData = [];
        let visaSubmitDataResponse = {};
        let disputeResponseReason;
        let index = -1;
        let attachIndex = -1;
        dataColumns.forEach(dataColumn => {
            let reviewAttachArray = [];
            let reviewSubmitAttachArray = [];
            if (dataColumn.displayType == 'CHECKBOX' && dataColumn.isChecked) {
                index++;
                if (dataColumn.attachArray) {
                    dataColumn.attachArray.forEach(column => {
                        attachIndex = dataColumns.findIndex(attachColumn => attachColumn.columnKey === column.columnKey);
                        if (attachIndex != -1 && dataColumns[attachIndex].value) {
                            if (dataColumns[attachIndex].displayType == 'SINGLEDATE') {
                                let reviewAttachObject = {
                                    title: column.description,
                                    desc: dataColumns[attachIndex].value.format('LL')
                                }
                                let reviewSubmitAttachObject = {
                                    columnKey: dataColumns[attachIndex].columnKey,
                                    displayType: dataColumns[attachIndex].displayType,
                                    name: dataColumns[attachIndex].description,
                                    value: dataColumns[attachIndex].value.format('MM/DD/YYYY')
                                }
                                reviewAttachArray = [...reviewAttachArray,reviewAttachObject];
                                reviewSubmitAttachArray = [...reviewSubmitAttachArray,reviewSubmitAttachObject];
                            }
                            else if (dataColumns[attachIndex].displayType == 'SINGLECRCTTRSNDATE') {
                                let reviewAttachObject = {
                                    title: column.description,
                                    desc: dataColumns[attachIndex].value.format('LL')
                                }
                                let reviewSubmitAttachObject = {
                                    columnKey: dataColumns[attachIndex].columnKey,
                                    displayType: dataColumns[attachIndex].displayType,
                                    name: dataColumns[attachIndex].description,
                                    value: dataColumns[attachIndex].value.format('MM/DD/YYYY')
                                }
                                reviewAttachArray = reviewAttachArray.concat(reviewAttachObject);
                                reviewSubmitAttachArray = reviewSubmitAttachArray.concat(reviewSubmitAttachObject);
                            }
                            else if (dataColumns[attachIndex].displayType == 'TIME') {
                                let reviewAttachObject = {
                                    title: column.description,
                                    desc: dataColumns[attachIndex].value.format('hh:mm:ss a'),
                                }
                                let reviewSubmitAttachObject = {
                                    columnKey: dataColumns[attachIndex].columnKey,
                                    displayType: dataColumns[attachIndex].displayType,
                                    name: dataColumns[attachIndex].description,
                                    value: dataColumns[attachIndex].value.format('hh:mm:ss a')
                                }
                                reviewAttachArray = reviewAttachArray.concat(reviewAttachObject);
                                reviewSubmitAttachArray = reviewSubmitAttachArray.concat(reviewSubmitAttachObject);
                            }
                            else {
                                let reviewAttachObject = {
                                    title: column.description,
                                    desc: dataColumns[attachIndex].value.toString()
                                }
                                let reviewSubmitAttachObject = {
                                    columnKey: dataColumns[attachIndex].columnKey,
                                    displayType: dataColumns[attachIndex].displayType,
                                    name: dataColumns[attachIndex].description,
                                    value: dataColumns[attachIndex].value.toString(),
                                }
                                reviewAttachArray = reviewAttachArray.concat(reviewAttachObject);
                                reviewSubmitAttachArray = reviewSubmitAttachArray.concat(reviewSubmitAttachObject);
                            }
                        }
                    });
                    let reviewObject = {
                        title: selectedOptions[index],
                        desc: dataColumn.description,
                        attachArray: reviewAttachArray,
                    };
                    let reviewSubmitObject = {
                        columnKey: dataColumn.columnKey,
                        displayType: dataColumn.displayType,
                        name: dataColumn.description,
                        subOptions: reviewSubmitAttachArray,
                        value: 'true'
                    }
                    visaSubmitDataResponse[dataColumn.columnKey] = reviewSubmitObject;
                    visaQnReviewData = [...visaQnReviewData,reviewObject];
                }
                else if (dataColumn.columnKey != 'idCollaborationCheckbox') {
                    let reviewObject = {
                        title: selectedOptions[index],
                        desc: dataColumn.description,
                        attachArray: [],
                    };
                    let reviewSubmitObject = {
                        columnKey: dataColumn.columnKey,
                        displayType: dataColumn.displayType,
                        name: dataColumn.description,
                        subOptions: [],
                        value: 'true',
                    }
                    visaSubmitDataResponse[dataColumn.columnKey] = reviewSubmitObject;
                    visaQnReviewData = visaQnReviewData.concat(reviewObject);
                } else {
                    let reviewSubmitObject = {
                        columnKey: dataColumn.columnKey,
                        displayType: dataColumn.displayType,
                        name: dataColumn.description,
                        subOptions: [],
                        value: 'true',
                    }
                    visaSubmitDataResponse[dataColumn.columnKey] = reviewSubmitObject;
                }
            }
            else if (dataColumn.displayType == 'DROPDOWN' && dataColumn.selectedOption) {
                let alreadyPresentIndex = visaQnReviewData.findIndex(reviewData => reviewData.title === dataColumn.description);
                if (alreadyPresentIndex == -1) {
                    let reviewObject = {
                        title: dataColumn.description,
                        desc: dataColumn.selectedOption.text,
                        attachArray: [],
                    };
                    let reviewSubmitObject = {
                        columnKey: dataColumn.columnKey,
                        displayType: dataColumn.displayType,
                        name: dataColumn.description,
                        subOptions: reviewSubmitAttachArray,
                        value: dataColumn.selectedOption.value
                    }
                    dataColumn.columnKey == 'responseReason' ? disputeResponseReason = dataColumn.selectedOption.value : null;
                    visaSubmitDataResponse[dataColumn.columnKey] = reviewSubmitObject;
                    visaQnReviewData = visaQnReviewData.concat(reviewObject);
                }
            }
            else if (dataColumn.displayType != 'CHECKBOX' && dataColumn.displayType != 'LINE' && dataColumn.displayType != 'LABEL' && dataColumn.displayType != 'DROPDOWN' && dataColumn.value) {
                let alreadyPresentIndex = visaQnReviewData.findIndex(reviewData => reviewData.title === dataColumn.description);
                let alreadyAttachedIndex = -1;
                visaQnReviewData.forEach(reviewData => {
                    if (reviewData.attachArray.length != 0) {
                        reviewData.attachArray.forEach(attachObj => {
                            attachObj.title === dataColumn.description ? alreadyAttachedIndex = 0 : null;
                        });
                    }
                })
                if (alreadyPresentIndex == -1 && alreadyAttachedIndex == -1) {
                    if (dataColumn.displayType == 'SINGLEDATE') {
                        let reviewObject = {
                            title: dataColumn.description,
                            desc: dataColumn.value.format('LL'),
                            attachArray: [],
                        };
                        let reviewSubmitObject = {
                            columnKey: dataColumn.columnKey,
                            displayType: dataColumn.displayType,
                            name: dataColumn.description,
                            subOptions: reviewSubmitAttachArray,
                            value: dataColumn.value.format('MM/DD/YYYY')
                        }
                        visaSubmitDataResponse[dataColumn.columnKey] = reviewSubmitObject;
                        visaQnReviewData = visaQnReviewData.concat(reviewObject);
                    }
                    else if (dataColumn.displayType == 'SINGLECRCTTRSNDATE') {
                        let reviewObject = {
                            title: dataColumn.description,
                            desc: dataColumn.value.format('LL'),
                            attachArray: [],
                        };
                        let reviewSubmitObject = {
                            columnKey: dataColumn.columnKey,
                            displayType: dataColumn.displayType,
                            name: dataColumn.description,
                            subOptions: reviewSubmitAttachArray,
                            value: dataColumn.value.format('MM/DD/YYYY')
                        }
                        visaSubmitDataResponse[dataColumn.columnKey] = reviewSubmitObject;
                        visaQnReviewData = visaQnReviewData.concat(reviewObject);
                    }
                    else if (dataColumn.displayType == 'TIME') {
                        let reviewObject = {
                            title: dataColumn.description,
                            desc: dataColumn.value.format('hh:mm:ss a'),
                            attachArray: [],
                        };
                        let reviewSubmitObject = {
                            columnKey: dataColumn.columnKey,
                            displayType: dataColumn.displayType,
                            name: dataColumn.description,
                            subOptions: reviewSubmitAttachArray,
                            value: dataColumn.value.format('hh:mm:ss a')
                        }

                        visaSubmitDataResponse[dataColumn.columnKey] = reviewSubmitObject;
                        visaQnReviewData = visaQnReviewData.concat(reviewObject);
                    } else {
                        let reviewObject = {
                            title: dataColumn.description,
                            desc: dataColumn.value.toString(),
                            attachArray: [],
                        };
                        let reviewSubmitObject = {
                            columnKey: dataColumn.columnKey,
                            displayType: dataColumn.displayType,
                            name: dataColumn.description,
                            subOptions: reviewSubmitAttachArray,
                            value: dataColumn.value.toString()
                        }
                        visaSubmitDataResponse[dataColumn.columnKey] = reviewSubmitObject;
                        visaQnReviewData = visaQnReviewData.concat(reviewObject);
                    }
                }
            }
        });
        this.props.setQuestionnaireReviewData(visaQnReviewData);
        this.props.setVisaQuestionnaireSubmitData(visaSubmitDataResponse, disputeResponseReason, this.props.reasonCodeCategory, this.props.reasonCode);
    }

    getResponseReasonFilteredByReasonCodeLevelTwo(apiComponentListLevelTwo,occuranceIndex,dataColumnListIndex){
        if (this.props.reasonCode == __REASON_CODE_104__ && apiComponentListLevelTwo[occuranceIndex].reason == __CE_COMPELLING_EVIDENCE__
            && apiComponentListLevelTwo[occuranceIndex].disputeType == __ALLOCATION__) {
            let filteredList = apiComponentListLevelTwo[occuranceIndex].dataColumns[dataColumnListIndex].list
                .filter((item) => (item.value !== __CE17__ && item.value !== __CE18__));
            return filteredList;

        } else if ((this.props.reasonCode == __REASON_CODE_101__ || this.props.reasonCode == __REASON_CODE_103__) && apiComponentListLevelTwo[occuranceIndex].reason == __CE_COMPELLING_EVIDENCE__
            && apiComponentListLevelTwo[occuranceIndex].disputeType == __ALLOCATION__) {
            let filteredList = apiComponentListLevelTwo[occuranceIndex].dataColumns[dataColumnListIndex].list
                .filter((item) => (item.value == __CE17__ || item.value == __CE18__));
            return filteredList;

        } else {
            return apiComponentListLevelTwo[occuranceIndex].dataColumns[dataColumnListIndex].list;
        }
    }

    getResponseReasonFilteredByReasonCode(responseReasonList) {
        if (this.props.reasonCode === __REASON_CODE_102__) {
            let filteredList = responseReasonList.filter((item) => (item.value !== __CE_COMPELLING_EVIDENCE__));
            responseReasonList = filteredList;
            return filteredList;
        } else if (this.props.reasonCode === __REASON_CODE_105__) {
            let filteredList = responseReasonList.filter((item) => (item.value !== __CE_COMPELLING_EVIDENCE__ && item.value !== __DC_DELAYED_CHARGE_TRANSACTION__ && item.value !== __ND_CARDHOLDER_NO_LONGER_DISPUTES__));
            responseReasonList = filteredList;
            return filteredList;
        } else if (this.props.reasonCode === __REASON_CODE_111__ || this.props.reasonCode === __REASON_CODE_112__ || this.props.reasonCode === __REASON_CODE_113__) {
            let filteredList = responseReasonList.filter((item) => (item.value !== __CE_COMPELLING_EVIDENCE__ && item.value !== __ND_CARDHOLDER_NO_LONGER_DISPUTES__ && item.value !== __DC_DELAYED_CHARGE_TRANSACTION__));
            responseReasonList = filteredList;
            return filteredList;
        } else if (this.props.reasonCode === __REASON_CODE_121__ || this.props.reasonCode === __REASON_CODE_122__ || this.props.reasonCode === __REASON_CODE_123__ || this.props.reasonCode === __REASON_CODE_124__ || this.props.reasonCode === __REASON_CODE_125__ || this.props.reasonCode === __REASON_CODE_1261__ || this.props.reasonCode === __REASON_CODE_1262__ || this.props.reasonCode === __REASON_CODE_127__ || this.props.reasonCode === __REASON_CODE_132__ || this.props.reasonCode === __REASON_CODE_134__ || this.props.reasonCode === __REASON_CODE_135__ || this.props.reasonCode === __REASON_CODE_136__ || this.props.reasonCode === __REASON_CODE_137__) {
            let filteredList = responseReasonList.filter((item) => (item.value !== __CE_COMPELLING_EVIDENCE__ && item.value !== __CDLT__ && item.value !== __RM_REVERSAL_ISSUED_BY_MERCHANT__ && item.value !== __FC__));
            responseReasonList = filteredList;
            return filteredList;
        } else if (this.props.reasonCode === __REASON_CODE_138__) {
            let filteredList = responseReasonList.filter((item) => (item.value !== __CE_COMPELLING_EVIDENCE__ && item.value !== __CNLD_CARDHOLDER_NO_LONGER_DISPUTES__ && item.value !== __CP_CREDIT_OR_REVERSAL_PROCESSED__ && item.value !== __CDLT__ && item.value !== __FC__));
            responseReasonList = filteredList;
            return filteredList;
        } else if (this.props.reasonCode === __REASON_CODE_139__) {
            let filteredList = responseReasonList.filter((item) => (item.value !== __CE_COMPELLING_EVIDENCE__ && item.value !== __FC__));
            responseReasonList = filteredList;
            return filteredList;
        } else if (this.props.reasonCode === __REASON_CODE_101__ || this.props.reasonCode === __REASON_CODE_104__ ){
            let filteredList = responseReasonList.filter((item) => (item.value !== __EVIDENCE_OF_IMPRINT__));
            responseReasonList = filteredList;
            return filteredList;
        } else if (  this.props.reasonCode === __REASON_CODE_131__ || this.props.reasonCode === __REASON_CODE_133__ ) {
            let filteredList = responseReasonList.filter((item) => (item.value !== __CE_COMPELLING_EVIDENCE__ && item.value !== __CDLT__ && item.value !== __RM_REVERSAL_ISSUED_BY_MERCHANT__));
            responseReasonList = filteredList;
            return filteredList;
        }
        else {
            return responseReasonList;
        }
    }

    render() {
        const questionnaireForm = this.state && this.state.dataColumns && this.state?.dataColumns?.map((dataColumn, dataColumnIndex) => {
            let textAreaWidth
            if (dataColumn.columnKey === 'ce03AlocAddress1' || dataColumn.columnKey === 'ce03AlocAddress2'){
                textAreaWidth = dataColumn.width - 25
                dataColumn.className = 'textAreaStyleAddress'
            } else {
                textAreaWidth = dataColumn.width ? dataColumn.width :''
            }
            
          return (
                <div key={dataColumn.columnKey} style={dataColumn.float  && dataColumn.paddingLeft? { width: dataColumn.width, float: dataColumn.float,paddingLeft:dataColumn.paddingLeft } :dataColumn.float?{ width: dataColumn.width, float: dataColumn.float}: { width: dataColumn.width }} className={dataColumn.displayType == 'CURRENCY' ? 'action-issuer-component-wrapper amount-currency-align' :'action-issuer-component-wrapper'} >
                    {/** SelectInput is for questionniare and Add message and notes to show dropdown */}
                    {this.state.showDocIndBanner && this.renderResponseBanner(this.state.bannerTitle, this.state.bannerDesc)}
                    {this.state.isInvalidSelection && this.renderInvalidSelectionResponseBanner()}
                    {dataColumn.displayType == __DROP_DOWN__ && !dataColumn.hidden && <TextField
                        fieldClass="field--fixed-width"
                        htmlFor={dataColumn.name}
                        labelContent={<span data-radium>
                            <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}` }} htmlFor="user-permissions-list" labelClass="field-label checkbox-group-parent-label">{dataColumn.name}</Label>
                        </span>}
                        width={dataColumn.float ? dataColumn.width - 25 : dataColumn.width}
                    >
                        <div style={(dataColumn.list && dataColumn.list.length == 0) || !dataColumn.list ? { marginBottom: '16px', cursor: 'not-allowed', pointerEvents: 'none' } : { marginBottom: '16px' }}>
                            <SelectInput
                                selectClass={{ zIndex: 2 }}
                                dataList={dataColumn.list ? dataColumn.list : []}
                                promptText={(dataColumn.list && dataColumn.list.length == 0) || !dataColumn.list ? '- No Data Found -' : '- Select -'}
                                isDisabled={(dataColumn.list && dataColumn.list.length == 0) || !dataColumn.list ? true : false}
                                wrapperClass="select-menu__form reports"
                                extraClass="option-box"
                                elementStyle={{
                                    width: dataColumn.float ? dataColumn.width - 25 : dataColumn.width,
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden'
                                }}
                                handleSelection={this.onSelectionChange}
                                selectedItem={dataColumn.selectedOption}
                                disputeType={dataColumn.disputeType}
                                reason={dataColumn.reason}
                            />
                        </div>
                    </TextField>}
                    {
                        dataColumn.displayType == 'LABEL' && <Label extraStyle={{ fontSize: 14, fontWeight: 600, color: '#000000' }} htmlFor="purpose-of-transfer-list" labelClass="field-label">{dataColumn.description}</Label>
                    }
                    {
                        dataColumn.displayType == 'LINE' && <div style={{ borderBottom: '1px', borderBottomStyle: 'solid', float: 'left', width: '700px', borderBottomColor: '#d7dce1' }}></div>
                    }
                    {
                        dataColumn.displayType == 'TEXT' && <TextInput
                            label={dataColumn.description}
                            name={dataColumn.name}
                            onChange={this.handleInputToState(dataColumnIndex)}
                            value={dataColumn.value ? dataColumn.value : ''}
                            type={dataColumn.inputType ? dataColumn.inputType : 'text'}
                            width={dataColumn.float ? dataColumn.width - 25 : dataColumn.width}
                            isRequired={dataColumn.required}
                            extraClass={dataColumn.className ? dataColumn.className : 'text-input-questionnaire'}
                            extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}`}}
                            max={dataColumn?.max}
                            error={dataColumn.errorMsg || ''}
                        />


                    }
                    {
                        dataColumn.displayType == 'AMOUNT' && this.props.reasonCode === __REASON_CODE_123__ && <TextInput
                            label={dataColumn.description}
                            name={dataColumn.name}
                            onChange={this.handleInputToState(dataColumnIndex)}
                            value={dataColumn.value ? dataColumn.value : ''}
                            type={dataColumn.inputType ? dataColumn.inputType : 'text'}
                            width={dataColumn.float ? dataColumn.width - 25 : dataColumn.width}
                            isRequired={dataColumn.required}
                            isRequiredText={true}
                        /> 
                    }
                    {<div className ="currency-inline">{ dataColumn.displayType == 'CURRENCY' && this.props.reasonCode === __REASON_CODE_123__ && <TextInput
                        value={dataColumn.value ? dataColumn.value : ''}
                        type={dataColumn.inputType ? dataColumn.inputType : 'text'}
                        onChange={this.handleInputToStateValidate(dataColumnIndex,true)}
                        width={dataColumn.currencyWidth}
                        isRequired={dataColumn.required}
                    />
                    }
                    </div>}
                    {dataColumn.displayType == 'TEXTAREA' && <div style={{ marginTop: dataColumn.marginTop }}>
                        <TextField
                            fieldClass="field--fixed-width"
                            htmlFor={dataColumn.name}
                            labelContent={<span data-radium>
                                <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}` }} htmlFor="user-permissions-list" labelClass="field-label checkbox-group-parent-label-note">{dataColumn.name} 
                                <span>
                                {dataColumn.columnKey == 'aIDRA6CertOnAuth' &&<InformationBubble
                                id={dataColumn.name}
                                info
                                position="end"
                                tooltipContent={dataColumn.tooltipContent}
                               />}
                                </span>
                                <span style={{ float: 'right', fontSize: 12, fontWeight: 400, color: `${COLORS.oneGp.black}` }}>{dataColumn.length}/{dataColumn.textAreaMaxLength}
                               
                                    
                              </span></Label>
                            
                            </span>}
                            width={textAreaWidth}
                            display="inline-block">


                            <div style={{ marginTop: 11, marginBottom: 11 }}><textarea value={dataColumn.value} ref="notes" id="textArea" maxLength={dataColumn.textAreaMaxLength} onChange={this.handleInputToState(dataColumnIndex)} style={{height: dataColumn.height,width:textAreaWidth}} className={`custom-textarea ${dataColumn.className || ''}`} /></div>
                        </TextField>
                    </div>}
                    {
                        dataColumn.displayType == 'SINGLEDATE' &&
                        <div className="single-date-wrapper" style={{ width: dataColumn.width, paddingRight: dataColumn.paddingRight }}>
                            <SingleDateInput
                                id={dataColumnIndex}
                                name={dataColumn.name}
                                onApply={this.onSingleDateChange}
                                title={dataColumn.name}
                                singleDate={dataColumn.value}
                                minDate={moment().subtract(10, 'years')}
                                dateFormat='MM/DD/YYYY'
                                isRequired={dataColumn?.required} 
                            />
                        </div>
                    }
                    {
                        dataColumn.displayType == 'SINGLECRCTTRSNDATE' && this.props.reasonCode === __REASON_CODE_113__ &&
                        <div className="single-date-wrapper" style={{ width: dataColumn.width, paddingRight: dataColumn.paddingRight }}>
                            <SingleDateInput
                                id={dataColumnIndex}
                                name={dataColumn.name}
                                onApply={this.onSingleDateChange}
                                title={dataColumn.name}
                                singleDate={dataColumn.value}
                                maxDate={moment()}
                                dateFormat='MM/DD/YYYY'
                                isRequired={dataColumn?.required} 
                            />
                        </div>
                    }
                    {
                        dataColumn.displayType == 'TIME' && <TextField
                            htmlFor={dataColumn.name}
                            labelContent={<span>
                                <Label extraStyle={{ fontSize: '0.9714em', fontWeight: 700, color: '#000000' }} htmlFor="user-permissions-list">{dataColumn.name}</Label>
                            </span>}
                            width={dataColumn.float ? dataColumn.width - 25 : dataColumn.width}
                        >
                            <TimePickerTool
                                use12Hours={true}
                                disabled={false}
                                placeholder=""
                                format="h:mm:ss a"
                                className="time-picker-custom"
                                popupClassName="time-picker-popup-custom"
                                onTimeChange={this.onTimeChange}
                                index={dataColumnIndex}
                                width={dataColumn.width}
                                popupWidth={dataColumn.width}
                                value={dataColumn.value}
                            />
                        </TextField>
                    }
                    {
                        dataColumn.displayType == 'CHECKBOX' && <TextField
                            htmlFor="comment-box"
                        >
                            {
                                <Checkbox
                                    key={dataColumnIndex}
                                    checkBoxKey={dataColumnIndex}
                                    label={dataColumn.description}
                                    extraClass={dataColumn.extraClass}
                                    id="activeRuleCheckBox"
                                    isChecked={dataColumn.isChecked}
                                    onChange={this.toggleCheckBoxes}
                                    extraLabelStyle={{
                                        color: '#000000',
                                        background: 'unset',
                                        fontSize: 'larger',
                                        paddingLeft: 14,
                                        paddingTop: 3,
                                        display: 'inline-flex',
                                        borderBottom: '10px',
                                    }}
                                />
                            }
                        </TextField>
                    }
                </div>
            );
        });

        return (
            <div style={{ minHeight: 229,maxWidth:750 }}>
                {(this.state.isLevelOneLoading || this.state.isLevelTwoLoading || this.state.isLevelThreeLoading || this.state.autoPopulateDetailsLoading) ? <BVLoader20 /> : questionnaireForm}
            </div>
        );
    }
}


export default Questionnaire;

